import { render, staticRenderFns } from "./DisputeResolutionFormDetails.vue?vue&type=template&id=c2698582&scoped=true&"
import script from "./DisputeResolutionFormDetails.vue?vue&type=script&lang=js&"
export * from "./DisputeResolutionFormDetails.vue?vue&type=script&lang=js&"
import style0 from "./DisputeResolutionFormDetails.vue?vue&type=style&index=0&id=c2698582&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2698582",
  null
  
)

export default component.exports